import { TOKEN_EXPIRED_MESSAGE } from "../constants/app";
var isTokenExpiredError = function isTokenExpiredError(error) {
  return error.message.includes(TOKEN_EXPIRED_MESSAGE);
};
export default isTokenExpiredError;